import { createIamClient } from '@infuse/api/common';

const client = createIamClient('/rest/features');

export const getIamFeatures = async function (): Promise<string[]> {
  try {
    const response = await client.get<string[]>('');
    return response.data;
  } catch (error: any) {
    return [];
  }
};